export const GET_ALL_REGISTRATION_OF_CHANGES = "GET_ALL_REGISTRATION_OF_CHANGES"
export const CREATE_REGISTRATION_OF_CHANGES = "CREATE_REGISTRATION_OF_CHANGES"

